import axiosInstance from "./axiosInstance";

// ---------------- CREATE NEWS (Stay In Touch) ----------------
export const createNews = async (newsData) => {
  try {
    const response = await axiosInstance.post(
      "/createnews",
      newsData
    );

    // assuming API returns { status, message, data }
    return response.data;

  } catch (error) {
    console.error("Failed to create news:", error);
    throw error;
  }
};

export const getImage = async () => {
  try {
    const response = await axiosInstance.get("/image");
    return response.data.data; // assuming API returns {status, data}
  } catch (error) {
    console.error("Failed to fetch Home:", error);
    throw error;
  }
};